import { Html5Qrcode } from "html5-qrcode";
import { useEffect, useRef } from "react";
import { useLazyGetCheckExistLocationQuery } from "./../../../services/apiSlice";

const QrScanner = (props) => {
  const { setLocationId, setIsActive } = props;

  const [refetch] = useLazyGetCheckExistLocationQuery();
  const scannerRef = useRef(null);

  useEffect(() => {
    if (scannerRef.current) return;

    const html5QrCode = new Html5Qrcode("reader");
    scannerRef.current = html5QrCode;

    const config = {
      fps: 10,
      qrbox: {
        width: 250,
        height: 250,
      },
      aspectRatio: 1.333334,
    };

    const success = (decodedText) => {
      const location_id = decodedText.split("/").at(-1).split("?")[0];
      setLocationId(location_id);
      refetch({ location_id })
        .unwrap()
        .then((response) => setIsActive(response.data));

      if (scannerRef.current?.isScanning) {
        scannerRef.current
          .stop()
          .then(() => {
            if (document.getElementById("reader")) {
              scannerRef.current?.clear().catch(() => {});
            }
          })
          .catch(console.warn);
      }
    };

    html5QrCode.start({ facingMode: "environment" }, config, success, undefined).catch((err) => {
      console.error("Error starting QR scanner:", err);
    });

    return () => {
      const scanner = scannerRef.current;
      if (!scanner) return;

      try {
        if (scanner.isScanning) {
          scanner
            .stop()
            .then(() => {
              if (document.getElementById("reader")) {
                scanner.clear().catch(() => {});
              }
            })
            .catch(() => {});
        } else {
          if (document.getElementById("reader")) {
            scanner.clear().catch(() => {});
          }
        }
      } catch (e) {
        // ignore
      }
      scannerRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id="reader" style={{ width: "100%" }} />;
};

export default QrScanner;
